import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable, Subject } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { config } from '../../config';
@Injectable()

export class ProductReleaseService {
    constructor(private httpClient: HttpClient) { }

    baseUrl: string = config.apiUrl;

    getHeaders(): HttpHeaders {
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return headers;
    }

    getChangeLogDetails(ProductReleaseId): Observable<any> {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/getProductChangeLogMaster/' + ProductReleaseId, { headers: this.getHeaders() })
            .map(response => {
                return response;
            })
    }

    getProductAllChangeLogDetails(ProductId): Observable<any> {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/v2/getAllChangeLogById/' + ProductId, { headers: this.getHeaders() })
            .map(response => {
                return response;
            })
    }

    checkRevisionNo(ReleaseFormdata): Observable<any> {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v2/getRevNo', ReleaseFormdata, { headers: this.getHeaders() })
            .map((response: Response) => {
                return response;
            })
    }

    checkDBVersion(DBVersion, ProductId, ProductReleaseId): Observable<any> {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/v2/getDBVersion/' + DBVersion + '/' + Number(ProductId) + '/' + Number(ProductReleaseId), { headers: this.getHeaders() })
            .map(response => {
                return response;
            })
    }

    getToken(body: any, header): Observable<any> {
        return this.httpClient.post(config.TokenGenerationUrl + 'connect/token', body, { headers: header })
            .map(response => {
                return response;
            })
    }

    getProductionRelease(ProductId): Observable<any> {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/getProductionRelease/' + ProductId, { headers: this.getHeaders() })
            .map(response => {
                return response;
            })
    }

    getReleaseByProductId(ProductId): Observable<any> {
        // Replacing with v4 API to get Customer list for Pilot and Custom release
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/v4/getReleasesForProduct/' + ProductId, { headers: this.getHeaders() })
            .map(response => {
                return response;
            })
    }

    getReleaseProductsListByProductCode(ProductCode, ProductId, Variant): Observable<any> {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/v2/getReleaseProductsListByProductCode/' + ProductCode + '/' + ProductId + '/' + Variant, { headers: this.getHeaders() })
            .map(response => {
                return response;
            })
    }

    getIsAllowedToAddReleaseByProductId(ProductId): Observable<any> {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/v2/IsAddRelease/' + ProductId, { headers: this.getHeaders() })
            .map(response => {

                return response;
            })
    }

    getProductReleaseById(ProductReleaseId): Observable<any> {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/getReleaseProductDetailById/' + ProductReleaseId, { headers: this.getHeaders() })
            .map(response => {
                return response;
            })
    }

    getStableRelease(ApplicationCode): Observable<any> {
        return this.httpClient.get(this.baseUrl + 'Operations/v2/GetSoftwareUpdates?ApplicationCode=' + ApplicationCode + '&ReleaseStatus=1&DBVersion=&AppVersion=', { headers: this.getHeaders() })
            .map(response => {
                return response;
            });

    }

    // Revision File Upload
    UploadFiles(files: any): Observable<any> {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v2/UploadFile', files, { headers: this.getHeaders(), reportProgress: true, observe: 'events' })
            .map(response => {
                return response;
            })
    }

    PackageUploadFiles(files: any): Observable<any> {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v2/UploadPackageFiles', files, { headers: this.getHeaders(), reportProgress: true, observe: 'events' })
            .map(response => {
                return response;
            })
    }

    addProductReleaseMenually(ReleaseFormdata: any): Observable<any> {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v2/addProductRelease', ReleaseFormdata, { headers: this.getHeaders() })
            .map((response: Response) => {
                return response;
            })
    }

    deleteProductReleaseSupportFile(ProductReleaseSupportFileId): Observable<any> {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/DeleteProductReleaseSupportFile/' + ProductReleaseSupportFileId, { headers: this.getHeaders() })
            .map(response => {
                return response;
            })
    }

    updateProductReleaseDetail(ReleaseFormdata: any): Observable<any> {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v2/updateProductRelease', ReleaseFormdata, { headers: this.getHeaders() })
            .map((response: Response) => {
                return response;
            })
    }

    // Revert Release
    ActiveRelease(ReleaseFormdata: any): Observable<any> {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v2/ActiveRelease', ReleaseFormdata, { headers: this.getHeaders() })
            .map((response: Response) => {
                return response;
            })
    }

    //Approve Release
    ApproveRelease(ReleaseFormdata: any): Observable<any> {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v2/ApproveRelease', ReleaseFormdata, { headers: this.getHeaders() })
            .map((response: Response) => {
                return response;
            })
    }

    //Reject Release
    RejectRelease(ReleaseFormdata: any): Observable<any> {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/RejectRelease', ReleaseFormdata, { headers: this.getHeaders() })
            .map((response: Response) => {
                return response;
            })
    }

    // STP Start
    STPStart(ReleaseFormdata: any): Observable<any> {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v2/STPStart', ReleaseFormdata, { headers: this.getHeaders() })
            .map((response: Response) => {
                return response;
            })

    }

    // ViewHistory Release
    ViewHistory(ProductReleaseId: any): Observable<any> {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/GetProductRelaseHistory/' + ProductReleaseId, { headers: this.getHeaders() })
            .map(response => {
                return response;
            })

    }

    // Download Azure Container
    DownloadFile(LicenseInfo: any): Observable<any> {
        return this.httpClient.post(this.baseUrl + 'Operations/v2/DownloadZipFile', LicenseInfo, { responseType: 'blob', reportProgress: true, observe: 'events', headers: this.getHeaders() })
            .map(result => {
                return result;
            })
    }

    VerifySCAL360OTPVerification(LicenseInfo: any): Observable<any> {
        return this.httpClient.post(this.baseUrl + 'Operations/v2/VerifySCAL360OTPVerification?AuthKey=SensitActivationKey', LicenseInfo, { headers: this.getHeaders() })
            .map(result => {
                return result;
            })

    }

    SendEmailToSCAL3609Customer(LicenseInfo: any): Observable<any> {
        return this.httpClient.post(this.baseUrl + 'Operations/V2/SendEmailToSCAL360Customer', LicenseInfo, { headers: this.getHeaders() })
            .map(result => {
                return result;
            })

    }

    DownloadReleaseFile(ProductReleaseId: any): Observable<any> {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/v2/DownloadFile/' + ProductReleaseId, { responseType: 'blob', reportProgress: true, observe: 'events', headers: this.getHeaders() })
            .map(result => {
                return result;
            })

    }

    //Release status change through email notification 
    SendEmail(Emaildata: any): Observable<any> {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v2/SendEmail', Emaildata, { headers: this.getHeaders() })
            .map((response: Response) => {
                return response;
            })
    }  

    SendEmailToSyncItClientAdmins(Emaildata: any): Observable<any> {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v4/emails/syncit-client-admins', Emaildata, { headers: this.getHeaders() })
            .map((response: Response) => {
                return response;
            })
    }  

    getSASToken(filePath: any): Observable<any> {
        return this.httpClient.get(this.baseUrl + 'operations/v2/generate-sas-token?blobName=' + filePath, { headers: this.getHeaders() })
            .map(result => {
                return result;
            })
    }

    getIPAddress(): Observable<any> {
        return this.httpClient.get(this.baseUrl + 'operations/v2/get-ip', { headers: this.getHeaders() })
            .map(result => {
                return result;
            })
    }

    AddSoftwareDownloadDetails(requestInfo): Observable<any> {
        return this.httpClient.post(this.baseUrl + 'operations/v2/AddSoftwareDownloadDetails', requestInfo, { headers: this.getHeaders() })
            .map(result => {
                return result;
            })
    }

    ChangePilotCustomReleaseStatus(ReleaseFormdata: any): Observable<any> {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v4/ChangePilotCustomReleaseStatus', ReleaseFormdata, { headers: this.getHeaders() })
            .map((response: Response) => {
                return response;
            })
    }

    ActivateRelease(ReleaseFormdata: any): Observable<any> {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v4/ActivateRelease', ReleaseFormdata, { headers: this.getHeaders() })
            .map((response: Response) => {
                return response;
            })
    }

    getCustomers(productId: string): Observable<any> {
        return this.httpClient.get(this.baseUrl + `ReleaseManagement/v4/GetCustomerList?productId=${productId}`, { headers: this.getHeaders() })
            .map((response) => {
                return response;
            })
    }

    private notify = new Subject<any>();
    notifyObservable$ = this.notify.asObservable();
    public notifyOther(data: any) {
        if (data) {
            this.notify.next(data);
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/ProductReleaseService.ts